module.exports = __webpack_public_path__ + "media/images/icon-sort-active-27cb2463f76016f8f5374f6e17bc0c6d.png";